/* Maison Brogi — product page (port of original `s9` + recently viewed `t9`).
   Gallery thumbnails, variant select, quantity stepper, sticky mobile add-to-bag, recently viewed, ViewContent pixel,
   "Complete the ritual" complementary rows, payment-terms refresh on variant change. */
(function () {
  'use strict';

  // Literal class names (so Tailwind keeps them): border-foreground border-transparent hover:border-muted-foreground/30
  var THUMB_ACTIVE = ['border-foreground'];
  var THUMB_INACTIVE_DESKTOP = ['border-transparent', 'hover:border-muted-foreground/30'];
  var THUMB_INACTIVE_MOBILE = ['border-transparent'];

  function ready(fn) {
    var done = false;
    function run() {
      if (done || !(window.Brogi && window.Brogi.recentlyViewed)) return;
      done = true; fn();
    }
    run();
    if (!done) {
      document.addEventListener('brogi:ready', run);
      window.addEventListener('load', run);
    }
  }

  function initProduct(root) {
    if (root.__brogiProduct) return;
    root.__brogiProduct = true;

    var section = root.parentElement;
    var jsonEl = section.querySelector('[data-product-json]');
    var data = {};
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { data = { variants: [] }; }
    var handle = root.getAttribute('data-handle');
    var sticky = section.querySelector('[data-sticky-bar]');

    /* ---------- Gallery */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var current = slides.findIndex(function (s) { return !s.classList.contains('hidden'); });
    function show(i) {
      if (i === current || !slides[i]) return;
      current = i;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('hidden', !on);
        if (on) {
          var img = s.querySelector('img');
          if (img) img.loading = 'eager';
          s.classList.remove('brogi-pdp-fade'); void s.offsetWidth; s.classList.add('brogi-pdp-fade');
        }
      });
      thumbs.forEach(function (t) {
        var on = Number(t.getAttribute('data-thumb')) === i;
        var inactive = t.hasAttribute('data-thumb-mobile') ? THUMB_INACTIVE_MOBILE : THUMB_INACTIVE_DESKTOP;
        THUMB_ACTIVE.forEach(function (c) { t.classList.toggle(c, on); });
        inactive.forEach(function (c) { t.classList.toggle(c, !on); });
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.getAttribute('data-thumb'))); });
    });

    /* ---------- Variant + availability */
    var form = root.querySelector('form[data-product-form]');
    var idInput = root.querySelector('[data-variant-input]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyDisplay = root.querySelector('[data-qty-display]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var oos = root.querySelector('[data-oos]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('select[data-option-index]'));
    var variants = data.variants || [];
    var variant = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    function canBuy(v) { return !!data.preorder || (!!v && v.available && !data.forceSoldOut); }

    function paint() {
      if (!variant) return;
      var ok = canBuy(variant);
      if (idInput) idInput.value = variant.id;
      section.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = variant.price_formatted; });
      if (addBtn) addBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = data.preorder ? data.labels.preorder : ok ? data.labels.add : data.labels.soldout;
      if (oos) oos.hidden = ok;
      if (sticky) {
        var sb = sticky.querySelector('[data-sticky-add]');
        if (sb) sb.disabled = !ok;
        var a = sticky.querySelector('[data-sticky-can]'), b = sticky.querySelector('[data-sticky-cannot]');
        if (a) a.hidden = !ok;
        if (b) b.hidden = ok;
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var values = selects.map(function (s) { return s.value; });
        var idx = Number(sel.getAttribute('data-option-index'));
        var match = variants.find(function (v) { return values.every(function (val, k) { return v.options[k] === val; }); }) ||
          // original behaviour: first variant having the changed option value
          variants.find(function (v) { return v.options[idx] === sel.value; });
        if (!match) return;
        variant = match;
        selects.forEach(function (s) { var k = Number(s.getAttribute('data-option-index')); if (variant.options[k] != null) s.value = variant.options[k]; });
        paint();
        // Shop Pay Installments (payment_terms) listens to changes of the form's variant id input
        if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (variant.media_id) {
          var slide = root.querySelector('[data-slide][data-media-id="' + variant.media_id + '"]');
          if (slide) show(Number(slide.getAttribute('data-slide')));
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
        trackView();
      });
    });

    /* ---------- Quantity */
    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyInput) qtyInput.value = qty;
      if (qtyDisplay) qtyDisplay.textContent = qty;
    }
    var minus = root.querySelector('[data-qty-minus]'), plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    /* ---------- Sticky mobile bar */
    if (sticky) {
      var sbtn = sticky.querySelector('[data-sticky-add]');
      sbtn && sbtn.addEventListener('click', function () {
        if (sbtn.disabled || !variant || !window.BrogiCart) return;
        sbtn.setAttribute('aria-busy', 'true');
        window.BrogiCart.add(variant.id, qty, { title: data.title })
          .catch(function () {})
          .finally(function () { sbtn.removeAttribute('aria-busy'); });
      });
    }

    /* ---------- Pixel ViewContent (original fires on product + variant change) */
    function trackView() {
      try {
        if (window.fbq && window.Brogi && window.Brogi.consent && window.Brogi.consent() && variant) {
          window.fbq('track', 'ViewContent', {
            content_ids: [String(variant.id)],
            content_name: data.title,
            content_type: 'product',
            value: variant.price / 100,
            currency: data.currency || 'EUR'
          });
        }
      } catch (e) {}
    }

    ready(function () {
      if (window.Brogi && window.Brogi.recentlyViewed && handle) window.Brogi.recentlyViewed.add(handle);
      trackView();
    });

    root.querySelectorAll('[data-ritual]').forEach(initRitual);

    paint();
  }

  /* ---------- "Complete the ritual": Shopify complementary recommendations → fallback products */
  function initRitual(el) {
    if (el.__brogiRitual) return;
    el.__brogiRitual = true;
    var url = el.getAttribute('data-url');
    if (!url) return; // fallback rows are server-rendered
    var limit = Number(el.getAttribute('data-limit') || 2);
    var label = el.getAttribute('data-add-label');
    var exclude = el.getAttribute('data-exclude');
    var list = el.querySelector('[data-ritual-rows]');
    var tpl = el.querySelector('template[data-ritual-fallback]');

    function fill(rows) {
      rows = rows.filter(function (r) { return r.getAttribute('data-product-id') !== exclude; }).slice(0, limit);
      if (!rows.length) { el.hidden = true; return; }
      list.innerHTML = '';
      rows.forEach(function (r) {
        var l = r.querySelector('[data-ritual-add-label]');
        if (l && label) l.textContent = label;
        list.appendChild(r);
      });
      el.hidden = false;
    }
    function fallback() {
      var rows = tpl ? Array.prototype.slice.call(tpl.content.querySelectorAll('[data-ritual-row]')).map(function (r) { return document.importNode(r, true); }) : [];
      fill(rows);
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rows = Array.prototype.slice.call(doc.querySelectorAll('[data-ritual-results] [data-ritual-row]'));
        if (rows.length) fill(rows.map(function (r) { return document.importNode(r, true); }));
        else fallback();
      })
      .catch(fallback);
  }

  /* ---------- Recently viewed (original `t9`) */
  function initRecentlyViewed(el) {
    if (el.__brogiRv) return;
    el.__brogiRv = true;
    var currentHandle = el.getAttribute('data-current') || '';
    var limit = Number(el.getAttribute('data-limit') || 4);
    var allowed = null;
    try { allowed = JSON.parse(el.getAttribute('data-allowed') || 'null'); } catch (e) {}
    ready(function () {
      if (!window.Brogi || !window.Brogi.recentlyViewed) return;
      var handles = window.Brogi.recentlyViewed.items().filter(function (h) {
        return h !== currentHandle && (!allowed || !allowed.length || allowed.indexOf(h) !== -1);
      }).slice(0, limit);
      if (!handles.length) return;
      window.Brogi.fetchProductCards(handles).then(function (cards) {
        var html = cards.filter(Boolean);
        if (!html.length) return;
        var grid = el.querySelector('[data-rv-grid]');
        grid.innerHTML = html.join('');
        // restagger reveal delays like the original index-based animation
        Array.prototype.slice.call(grid.children).forEach(function (c, i) {
          var r = c.matches('[data-reveal]') ? c : c.querySelector('[data-reveal]');
          if (r) r.setAttribute('data-reveal-delay', String(i * 0.08));
        });
        el.hidden = false;
        if (window.Brogi.init) window.Brogi.init(el);
      });
    });
  }

  function boot(ctx) {
    (ctx || document).querySelectorAll('[data-product-page]').forEach(initProduct);
    (ctx || document).querySelectorAll('[data-recently-viewed]').forEach(initRecentlyViewed);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
